import React, { useState } from "react";
import LanguageSelector from "../Languages/LanguageSelector";
import Header from "./Header";
import Footer from "./Footer";
import I5 from "../../assets/4.ca8a5a1 (1).svg";
import I1 from "../../assets/1.512875a.svg";
import I2 from "../../assets/2.18a5b88.svg";
import I3 from "../../assets/3.7d9145c.svg";
import I4 from "../../assets/5.d6eee35.svg";
import M1 from "../../assets/freight3.7b30436.png";
import B1 from "../../assets/d2c.jpg";
import M3 from "../../assets/suit1.c860324.png";
import M2 from "../../assets/suit5.2700900.png";
import bgImage from "../../assets/pexels-tiger-lily-4481259.jpg";
import B2 from "../../assets/courier.jpg";
import B3 from "../../assets/B2B.jpg";

import toast from "react-hot-toast";
import { trackDelivery } from "../../features/dashboard/newBuilderSlice";
import { useDispatch } from "react-redux";
import { BackgroundGradient } from "../../components/Animations/BackgroundGradient";
import "./LandingPage.css";

const LandingPage = () => {
  const [activeTab, setActiveTab] = useState("order_id");
  const [orderId, setOrderId] = useState("");
  const [deliveryId, setDeliveryId] = useState("");
  const [errors, setErrors] = useState({ orderId: "", deliveryId: "" });

  const [showModal, setShowModal] = useState(false);
  const [trackingData, setTrackingData] = useState(null);

  const dispatch = useDispatch();
  const handleTrack = async () => {
    let id = "";
    const newErrors = { orderId: "", deliveryId: "" };

    if (activeTab === "order_id") {
      if (!orderId.trim()) {
        newErrors.orderId = "Please enter your Order ID";
      } else {
        id = orderId;
      }
    } else if (activeTab === "delivery_request_id") {
      if (!deliveryId.trim()) {
        newErrors.deliveryId = "Please enter your Delivery ID";
      } else {
        id = deliveryId;
      }
    }

    setErrors(newErrors);
    if (newErrors.orderId || newErrors.deliveryId) return;

    try {
      const result = await dispatch(
        trackDelivery({ tracking_mode: activeTab, id }),
      ).unwrap();

      toast.success(result.message || "Tracking details fetched successfully!");
      setTrackingData(result.data);
      setShowModal(true);

      setOrderId("");
      setDeliveryId("");
    } catch (err) {
      toast.error(err?.message || "Failed to track delivery");
    }
  };

  const stats = [
    {
      img: I1,
      value: "3.4 Bn+",
      label: "Parcels shipped since inception",
    },
    {
      img: I2,
      value: "99.5%",
      label: "Ethiopian population covered",
    },
    {
      img: I3,
      value: "33K+",
      label: "Businesses served",
    },
    {
      img: I4,
      value: "6.1 Mn+",
      label: "Tonnes Freight shipped",
    },
    {
      img: I5,
      value: "20 Mn+",
      label: "Square feet logistics infrastructure covered",
    },
  ];

  return (
    <>
      <div
        className="navbar-expand-lg navbar-light  fixed-top"
        style={{ zIndex: "99999" }}
      >
        <LanguageSelector />
      </div>
      <Header />

      <div
        className="position-relative "
        style={{
          paddingTop: "120px",
          maxHeight: "900px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            filter: "blur(2px)",

            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 0,
            transform: "scale(1.1)",
          }}
        ></div>
        <div
          className="position-relative text-center text-white"
          style={{ zIndex: 1 }}
        ></div>
        <div
          className="container-md container-fluid my-5 position-relative text-center text-white"
          style={{ zIndex: 1 }}
        >
          <div className="row align-items-center">
            {/* LEFT SECTION */}
            <div className="col-lg-6 mb-5 mb-md-0">
              <h1 className="fw-bold display-5 text-info">
                We are Ethiopia&apos;s largest fully integrated{" "}
                <span className=" text-info d-block">
                  fetan market services provider
                </span>
              </h1>

              <div className="d-flex flex-wrap mt-4">
                {[
                  "Express Parcel",
                  "PTL",
                  "FTL",
                  "Cross Border",
                  "Supply Chain",
                ].map((item, index) => (
                  <div
                    key={index}
                    className="d-flex align-items-center me-4 mb-3"
                  >
                    <div
                      className="me-2 rounded-circle"
                      style={{
                        width: "10px",
                        height: "10px",
                        backgroundColor: "#57a0e0",
                      }}
                    ></div>
                    <span className="fs-5">{item}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT SECTION */}

            <div className="col-lg-4">
              <BackgroundGradient>
                <div className="bg-white rounded shadow p-4">
                  {/* Tabs */}
                  <h3 className="fw-bold "> Track your order through</h3>

                  <ul className="nav nav-tabs mb-3">
                    {["order_id", "delivery_request_id"].map((tab) => (
                      <li className="nav-item" key={tab}>
                        <button
                          className={`nav-link ${
                            activeTab === tab ? "active text-danger" : ""
                          }`}
                          onClick={() => setActiveTab(tab)}
                        >
                          {
                            tab === "order_id" ? "Order Id" : "Delivery ID"
                            //   : tab === "orderId"
                            //   ? "Order ID"
                            //   : "LRN"
                          }
                        </button>
                      </li>
                    ))}
                  </ul>
                  {/* Tab Content */}
                  <div className="tab-content mb-3">
                    {activeTab === "order_id" ? (
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Order ID"
                          value={orderId}
                          onChange={(e) => setOrderId(e.target.value)}
                        />

                        {errors.orderId && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "0.9rem",
                              marginTop: "4px",
                            }}
                          >
                            {errors.orderId}
                          </p>
                        )}
                      </div>
                    ) : (
                      <div className="form-group">
                        <input
                          type="text"
                          placeholder="Enter Delivery ID"
                          value={deliveryId}
                          className="form-control"
                          onChange={(e) => setDeliveryId(e.target.value)}
                        />
                        {errors.deliveryId && (
                          <p
                            style={{
                              color: "red",
                              fontSize: "0.9rem",
                              marginTop: "4px",
                            }}
                          >
                            {errors.deliveryId}
                          </p>
                        )}
                      </div>
                    )}
                  </div>

                  <button
                    className="btn btn-light text-white w-100"
                    onClick={handleTrack}
                  >
                    Track Your Order
                  </button>
                </div>
              </BackgroundGradient>
            </div>
          </div>

          {showModal && trackingData && (
            <div
              className="modal fade show d-block"
              tabIndex="-1"
              style={{ backgroundColor: "rgba(0,0,0,0.5)", marginTop: "50px" }}
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content" style={{ textAlign: "left" }}>
                  <div className="modal-header d-flex justify-content-between bg-light">
                    <h5 className="modal-title text-info ">
                      Delivery Tracking Details
                    </h5>
                    <i
                      className="bi bi-x-lg fs-5 text-info cursor-pointer"
                      role="button"
                      onClick={() => setShowModal(false)}
                    ></i>
                  </div>
                  <div className="modal-body">
                    <p>
                      <strong>Order ID:</strong> {trackingData.order_id}
                    </p>
                    <p>
                      <strong>Delivery ID:</strong>{" "}
                      {trackingData.delivery_request_id}
                    </p>
                    <p>
                      <strong>Status:</strong>{" "}
                      <span className="badge bg-info text-dark">
                        {trackingData.status}
                      </span>
                    </p>
                    <hr />
                    <h6>Delivery Person Info</h6>
                    <p>
                      <strong>Name:</strong>{" "}
                      {trackingData.delivery_person_info.name}
                    </p>
                    <p>
                      <strong>Phone:</strong>{" "}
                      {trackingData.delivery_person_info.phone}
                    </p>
                    <p>
                      <strong>Email:</strong>{" "}
                      {trackingData.delivery_person_info.email}
                    </p>
                    <hr />
                    <h6>Addresses</h6>
                    <p>
                      <strong>Store Address:</strong>{" "}
                      {trackingData.store_address}
                    </p>
                    <p>
                      <strong>Delivery Address:</strong>{" "}
                      {trackingData.delivery_address}
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      className="btn btn-secondary text-info"
                      onClick={() => setShowModal(false)}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="my-5 text-center  " style={{ width: "100%" }}>
        {/* Heading */}
        <h2 className="fw-bold mb-2">
          Flexibility, Reliability and Scale
          <br />
          <span className="text-danger">The Answer is Fetan Delivery</span>
        </h2>

        {/* Red Line */}
        <div
          className="mx-auto mb-4"
          style={{
            width: "70px",
            height: "4px",
            backgroundColor: "#57a0e0",
            borderRadius: "4px",
          }}
        ></div>

        {/* Statistics Section */}

        <div className="row container mx-auto gy-4 justify-content-center">
          {stats.map((item, index) => (
            <div key={index} className="col-2-5 p-2">
              <div
                className="card border-0  text-center p-3 w-100 h-100 hover-card"
                style={{
                  transition: "all 0.3s ease",
                  borderRadius: "15px",
                  boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
                }}
              >
                <div className="card-body">
                  <div
                    className="d-flex justify-content-center align-items-center mb-3 rounded-circle mx-auto"
                    style={{
                      width: "70px",
                      height: "70px",
                      boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
                    }}
                  >
                    <img
                      src={item.img}
                      alt={item.label}
                      className="img-fluid"
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <h4 className="fw-bold text-danger mb-1">{item.value}</h4>
                  <p className="text-muted small mb-0">{item.label}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-dark text-white py-5">
        <div className="container py-5">
          <h2 className="fw-bold text-center mb-3">
            Fetan Delivery’s{" "}
            <span className="text-danger">suite of solutions for</span>
          </h2>
          <div
            className="mx-auto mb-4"
            style={{ width: "80px", height: "4px", backgroundColor: "#57a0e0" }}
          ></div>

          <div className="row gy-5 pt-3">
            {/* D2C Brands */}
            <div className="col-md-4 col-sm-6 d-flex flex-column justify-content-between">
              <div className="mb-3">
                <img
                  // src={M1}
                  alt="D2C Brands"
                  src={B1}
                  className="img-fluid mb-3"
                />
                <h3 className="h4 fw-semibold mb-2">D2C Brands</h3>
                <p className="text-white-50">
                  We provide an integrated logistics solution built on Express
                  Parcel, Cross Border, Warehousing, Freight and Software value
                  added services that helps brands deliver faster and provide a
                  superior experience.
                </p>
              </div>
              <a href="" className="text-light fw-bold text-decoration-none">
                Know More
              </a>
            </div>

            {/* Personal Courier */}
            <div className="col-md-4 col-sm-6 d-flex flex-column justify-content-between">
              <div className="mb-3">
                <img
                  // src={M1}
                  alt="Personal Courier"
                  src={B2}
                  className="img-fluid mb-3"
                />
                <h3 className="h4 fw-semibold mb-2">Personal Courier</h3>
                <p className="text-white-50">
                  Ethiopia's only online courier solution for all your personal
                  shipping needs. Send from your location to anywhere in the
                  country and internationally with free doorstep pickup and real
                  time tracking through our app.
                </p>
              </div>
              <a
                href="/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-light fw-bold text-decoration-none"
              >
                Know More
              </a>
            </div>

            {/* B2B Enterprises */}
            <div className="col-md-4 col-sm-6 d-flex flex-column justify-content-between">
              <div className="mb-3">
                <img
                  // src={M3}
                  src={B3}
                  alt="B2B Enterprises"
                  className="img-fluid mb-3"
                />
                <h3 className="h4 fw-semibold mb-2">B2B Enterprises</h3>
                <p className="text-white-50">
                  We provide customised solutions to serve your factory to
                  retailer supply chain end-to-end using our integrated
                  warehousing, technology capabilities and logistics network
                  that improve reliability and reduce cost.
                </p>
              </div>
              <a href="/" className="text-light fw-bold text-decoration-none">
                Know More
              </a>
            </div>
          </div>
        </div>
      </div>

      <div
        className="text-center py-5 px-4"
        style={{ backgroundColor: "#ffff" }}
      >
        <div className="container">
          <h2 className="fw-bold  mb-3">
            Experience the{" "}
            <span className="fw-bolder text-danger">operating system </span>
            for commerce in Ethiopia
          </h2>

          <p className="fs-5 mb-5">
            Sign up now to start shipping with Delhivery
          </p>

          <div className="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mt-4">
            {/* Personal Courier Button */}
            <a
              href="/auth/register"
              className="btn btn-light fw-semibold d-flex align-items-center justify-content-center py-3 px-4 rounded"
              style={{ minWidth: "220px", fontSize: "14px", color: "#fff" }}
            >
              Personal Courier
            </a>

            {/* Business Shipments Button */}
            <a
              href="/auth/register"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-light fw-semibold d-flex align-items-center justify-content-center py-3 px-4 rounded"
              style={{ maxWidth: "220px", fontSize: "14px", color: "#fff" }}
            >
              Business Shipments
            </a>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default LandingPage;
